import { create } from 'zustand';

const useConfirmDialogStore = create((set, get) => ({
  open: false,
  title: '',
  message: '',
  buttonTitle: '',
  isConfirmed: false,
  _promise: null,
  seekConfirmation: (title, message, buttonTitle) => {
    if (title && message && buttonTitle) {
      const promise = new Promise((resolve) => {
        set(() => ({
          open: true,
          title: title,
          message: message,
          buttonTitle: buttonTitle,
          _promise: { resolve },
        }));
      });
      return promise;
    }
    return null;
  },
  updateConfirmation: (isConfirmed) => {
    const { _promise } = get();
    if (_promise) {
      _promise.resolve(isConfirmed);
    }
    set(() => ({
      open: false,
      title: '',
      message: '',
      isConfirmed: false,
      _promise: null,
    }));
  },
}));

export default useConfirmDialogStore;
